import './style.sass';
import React, { ReactNode } from 'react';

type Props = {
    title: string,
    desc: ReactNode,
    titleClassName: string,
    descClassName: string,
    className?: string,
};

export const TextInfoItem = ({ title, desc, titleClassName, descClassName, className }: Props) => {
    return (
        <div className={`text-info-item ${className ? className : ''}`}>
            <span className={titleClassName}>{title}</span>

            {typeof desc === 'string'
                ? <span className={descClassName}>{desc}</span>
                : desc
            }
        </div>
    );
};
